import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addProfile, CamelCaseNamingConvention, createMap, forMember, ignore, mapFrom, MappingProfile, namingConventions, nullSubstitution, PascalCaseNamingConvention, typeConverter, undefinedSubstitution } from '@automapper/core';
import { Temporal } from '@js-temporal/polyfill';
import { AppModule } from './app/app.module';
import { AreaMapEntity, CassetteEntity, GlobalTaskEntity, InterventionEntity, MaterielAdductionEntity, MaterielEauEntity, MeanOfPreventionEntity, MeasureEauEntity, MeasureEntity, MeasureGenericEntity, MeasureLingetteEntity, MeasureMassifEntity, MesureAdductionEntity, MPCAEntity, OperatorEntity, PlageHoraireEntity, PointageJournalierEntity, PointagePauseEntity, PompeEntity, PrelevementAirEntity, ProcessCalculationEntity, ProcessEntity, ProcessMeasureEntity, ProcessSamplingConditionEntity, ProcessTechniqueEntity, SamplingPointEntity, SecuriteEntity, TaskEntity, UserEntity, ZoneEntity, ZoneSamplingConditionEntity } from './app/db/db';
import { AreaMap } from './app/domain/area-map';
import { Cassette } from './app/domain/cassette';
import { MaterielEau } from './app/domain/EAU/materiel-eau';
import { MeasureEau } from './app/domain/EAU/measure-eau';
import { GlobalTask } from './app/domain/global-task';
import { Intervention } from './app/domain/intervention';
import { MeasureLingette } from './app/domain/Lingette/measure-lingette';
import { MeasureMassif } from './app/domain/Massif/measure-massif';
import { MeanOfPrevention } from './app/domain/mean-of-prevention';
import { AppareilMesure } from './app/domain/appareil-meure';
import { MPCA } from './app/domain/mpca';
import { Operator } from './app/domain/operator';
import { PlageHoraire } from './app/domain/plage-horaire';
import { Pompe } from './app/domain/pompe';
import { Process } from './app/domain/process';
import { ProcessCalculation } from './app/domain/process-calculation';
import { ProcessMeasure } from './app/domain/process-mesure';
import { ProcessSamplingCondition } from './app/domain/process-sampling-condition';
import { ProcessTechnique } from './app/domain/process-technique';
import { PointageJournalier } from './app/domain/RH/pointage-journalier';
import { PointagePause } from './app/domain/RH/pointage-pause';
import { SamplingPoint } from './app/domain/sampling-point';
import { Securite } from './app/domain/securite';
import { Task } from './app/domain/task';
import { User } from './app/domain/user';
import { Zone } from './app/domain/zone';
import { ZoneMeasure } from './app/domain/zone-measure';
import { ZoneSamplingCondition } from './app/domain/zone-sampling-condition';
import { AreaMapDTO } from './app/services/dto/area-map.dto';
import { CassetteDTO } from './app/services/dto/cassette.dto';
import { GlobalTaskDTO } from './app/services/dto/global-task.dto';
import { InterventionDTO } from './app/services/dto/intervention.dto';
import { MaterielEauDTO } from './app/services/dto/materiel-eau.dto';
import { MeanOfPreventionDTO } from './app/services/dto/mean-of-prevention.dto';
import { MeasureEauDTO } from './app/services/dto/measure-eau.dto';
import { MeasureLingetteDTO } from './app/services/dto/measure-lingette.dto';
import { MeasureMassifDTO } from './app/services/dto/measure-massif.dto';
import { MetrologieDTO } from './app/services/dto/metrologie.dto';
import { MPCADTO } from './app/services/dto/mpca.dto';
import { OperatorDTO } from './app/services/dto/operator.dto';
import { PlageHoraireDTO } from './app/services/dto/plage-horaire.dto';
import { PointageJournalierDTO } from './app/services/dto/pointage-journalier.dto';
import { PointagePauseDTO } from './app/services/dto/pointage-pause.dto';
import { PompeDTO } from './app/services/dto/pompe.dto';
import { ProcessCalculationDTO } from './app/services/dto/process-calculation.dto';
import { ProcessMeasureDTO } from './app/services/dto/process-measure.dto';
import { ProcessSamplingConditionDTO } from './app/services/dto/process-sampling-condition.dto';
import { ProcessTechniqueDTO } from './app/services/dto/process-technique.dto';
import { ProcessDTO } from './app/services/dto/process.dto';
import { SamplingPointDTO } from './app/services/dto/sampling-point.dto';
import { SecuriteDTO } from './app/services/dto/securite.dto';
import { TaskDTO } from './app/services/dto/task.dto';
import { UserDTO } from './app/services/dto/user.dto';
import { ZoneMeasureDTO } from './app/services/dto/zone-measure.dto';
import { ZoneSamplingConditionDTO } from './app/services/dto/zone-sampling-condition.dto';
import { ZoneDTO } from './app/services/dto/zone.dto';
import { mapper } from './app/tools/mapping/mapper';
import { environment } from './environments/environment';
import { MesureAdduction } from './app/domain/Adduction-air/mesure-adduction';
import { MesureAdductionDTO } from './app/services/dto/mesure-adduction.dto';
import { MaterielAdduction } from './app/domain/Adduction-air/materiel-adduction';
import { MaterielAdductionDTO } from './app/services/dto/materiel-adduction.dto';
import { MaterielCompresseur } from './app/domain/Adduction-air/materiel-compresseur';
import { MaterielCompresseurDTO } from './app/services/dto/materiel-compresseur.dto';
import { PrelevementAir } from './app/domain/Adduction-air/prelevement-air';
import { PrelevementAirDTO } from './app/services/dto/prelevement-air.dto';
import { MeasureGenericDTO } from './app/services/dto/measure-generic.dto';
import { MeasureGeneric } from './app/domain/measure-generic';
import { polyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";

polyfill({
    // use this to make use of the scroll behaviour
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
});

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));

// SELF MAPPING
createMap(mapper, Process, Process,
    forMember((dest) => dest.VolumeRenouvellementAir, undefinedSubstitution(null))
);
createMap(mapper, MeasureLingette, MeasureLingette);
// DOM -> ENTITY

createMap(mapper, User, UserEntity);
createMap(mapper, Intervention, InterventionEntity,
    typeConverter(Temporal.PlainDate, String, (date) => date.toJSON()),
    forMember((dest) => dest.PlannedOnTimeSlot, mapFrom(source => source.TimeSlotPlannedOn)));
createMap(mapper, SamplingPoint, SamplingPointEntity);

createMap(mapper, MeasureMassif, MeasureMassifEntity,
    typeConverter(Temporal.PlainTime, String, (date) => date?.toJSON()));
createMap(mapper, MeasureEau, MeasureEauEntity,
    typeConverter(Temporal.PlainTime, String, (date) => date?.toJSON()));
createMap(mapper, MaterielEau, MaterielEauEntity,
    typeConverter(Temporal.PlainDate, String, (date) => date?.toJSON()));
createMap(mapper, MeasureLingette, MeasureLingetteEntity,
    typeConverter(Temporal.PlainTime, String, (date) => date?.toJSON()));

createMap(mapper, MesureAdduction, MesureAdductionEntity,
    typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
createMap(mapper, MaterielAdduction, MaterielAdductionEntity,
    forMember((dest) => dest.ReferenceHuile, mapFrom(source => source.MaterielCompresseur.ReferenceHuile)));
createMap(mapper, PrelevementAir, PrelevementAirEntity)

createMap(mapper, Zone, ZoneEntity,
    forMember((dest) => dest.BuildingTypeNonStandard, mapFrom(source => source.NonStandardBuildingType)),
    forMember((dest) => dest.RoomUsageNonStandard, mapFrom(source => source.NonStandardRoomUsage)));
createMap(mapper, MPCA, MPCAEntity);
createMap(mapper, ZoneSamplingCondition, ZoneSamplingConditionEntity,
    forMember((dest) => dest.Hygrometrie, undefinedSubstitution(null)),
    forMember((dest) => dest.VitesseVent, undefinedSubstitution(null)),
    forMember((dest) => dest.Meteo, undefinedSubstitution(null))
);
createMap(mapper, ZoneMeasure, MeasureEntity);
createMap(mapper, AreaMap, AreaMapEntity);

createMap(mapper, Process, ProcessEntity);

createMap(mapper, MeanOfPrevention, MeanOfPreventionEntity);
createMap(mapper, ProcessCalculation, ProcessCalculationEntity);
createMap(mapper, ProcessTechnique, ProcessTechniqueEntity);
createMap(mapper, GlobalTask, GlobalTaskEntity);
createMap(mapper, ProcessMeasure, ProcessMeasureEntity);
createMap(mapper, ProcessSamplingCondition, ProcessSamplingConditionEntity);

createMap(mapper, Cassette, CassetteEntity);
createMap(mapper, PlageHoraire, PlageHoraireEntity, typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));
createMap(mapper, Pompe, PompeEntity);
createMap(mapper, Securite, SecuriteEntity);

createMap(mapper, Operator, OperatorEntity);
createMap(mapper, Task, TaskEntity, typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));

createMap(mapper, PointageJournalier, PointageJournalierEntity, typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));
createMap(mapper, PointagePause, PointagePauseEntity, typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));

createMap(mapper, MeasureGeneric, MeasureGenericEntity)

// ENTITY -> DOM 

createMap(mapper, InterventionEntity, Intervention,
    typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined),
    forMember((dest) => dest.TimeSlotPlannedOn, mapFrom(source => source.PlannedOnTimeSlot)),
    forMember((dest) => dest.SituationPlan, ignore()));
createMap(mapper, UserEntity, User);
createMap(mapper, SamplingPointEntity, SamplingPoint);

createMap(mapper, MeasureMassifEntity, MeasureMassif,
    typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
createMap(mapper, MeasureEauEntity, MeasureEau,
    typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined),
    forMember((dest) => dest.MaterielEau, ignore()));
createMap(mapper, MaterielEauEntity, MaterielEau,
    typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined));
createMap(mapper, MeasureLingetteEntity, MeasureLingette,
    typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));

createMap(mapper, MesureAdductionEntity, MesureAdduction,
    typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
createMap(mapper, MaterielAdductionEntity, MaterielAdduction,
    forMember((dest) => dest.MaterielCompresseur.ReferenceHuile, mapFrom(source => source.ReferenceHuile)));
createMap(mapper, PrelevementAirEntity, PrelevementAir)

createMap(mapper, ProcessEntity, Process,
    forMember((dest) => dest.AreaMap, ignore()),
    forMember((dest) => dest.ProcessCalculation, ignore()))
createMap(mapper, ProcessMeasureEntity, ProcessMeasure,
    forMember((dest) => dest.ProcessSamplingCondition, ignore()),
    forMember((dest) => dest.Securite, ignore()));
createMap(mapper, ProcessTechniqueEntity, ProcessTechnique,
    forMember((dest) => dest.Mpca, ignore()));
createMap(mapper, ProcessSamplingConditionEntity, ProcessSamplingCondition);
createMap(mapper, GlobalTaskEntity, GlobalTask);
createMap(mapper, MeanOfPreventionEntity, MeanOfPrevention);
createMap(mapper, ProcessCalculationEntity, ProcessCalculation);
createMap(mapper, ZoneEntity, Zone,
    forMember((dest) => dest.NonStandardBuildingType, mapFrom(source => source.BuildingTypeNonStandard)),
    forMember((dest) => dest.NonStandardRoomUsage, mapFrom(source => source.RoomUsageNonStandard)));
createMap(mapper, AreaMapEntity, AreaMap);
createMap(mapper, MPCAEntity, MPCA);
createMap(mapper, MeasureEntity, ZoneMeasure,
    forMember((dest) => dest.Cassette, ignore()),
    forMember((dest) => dest.PoseSecurite, ignore()),
    forMember((dest) => dest.DeposeSecurite, ignore()),
    forMember((dest) => dest.ZoneSamplingCondition, ignore()));
createMap(mapper, ZoneSamplingConditionEntity, ZoneSamplingCondition);
createMap(mapper, SecuriteEntity, Securite);
createMap(mapper, OperatorEntity, Operator);
createMap(mapper, CassetteEntity, Cassette,
    forMember((dest) => dest.Pompe, ignore()));
createMap(mapper, TaskEntity, Task,
    typeConverter(String, Temporal.PlainDateTime, (date) => Temporal.PlainDateTime.from(date)));
createMap(mapper, PompeEntity, Pompe);
createMap(mapper, PlageHoraireEntity, PlageHoraire,
    typeConverter(String, Temporal.PlainDateTime, (date) => Temporal.PlainDateTime.from(date)));
createMap(mapper, MeasureGenericEntity, MeasureGeneric)

// DTO -> DOM
const dtoProfile: MappingProfile = (mapper) => {
    createMap(mapper, InterventionDTO, Intervention,
        forMember((dest) => dest.TimeSlotPlannedOn, mapFrom(source => source.plannedTimeSlot)),
        typeConverter(String, Temporal.PlainDate, (date) => Temporal.PlainDate.from(date)));
    createMap(mapper, UserDTO, User)
    createMap(mapper, SamplingPointDTO, SamplingPoint)

    createMap(mapper, MeasureEauDTO, MeasureEau,
        typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
    createMap(mapper, MaterielEauDTO, MaterielEau,
        typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined));
    createMap(mapper, MeasureMassifDTO, MeasureMassif,
        typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
    createMap(mapper, MeasureLingetteDTO, MeasureLingette,
        typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));

    createMap(mapper, MesureAdductionDTO, MesureAdduction,
        typeConverter(String, Temporal.PlainTime, (date) => date ? Temporal.PlainTime.from(date) : undefined));
    createMap(mapper, MaterielAdductionDTO, MaterielAdduction)
    createMap(mapper, MaterielCompresseurDTO, MaterielCompresseur)
    createMap(mapper, PrelevementAirDTO, PrelevementAir)

    createMap(mapper, ZoneDTO, Zone,
        forMember((dest) => dest.NonStandardBuildingType, mapFrom(source => source.buildingTypeNonStandard)),
        forMember((dest) => dest.NonStandardRoomUsage, mapFrom(source => source.roomUsageNonStandard)))
    createMap(mapper, ProcessDTO, Process)
    createMap(mapper, MPCADTO, MPCA)
    createMap(mapper, ZoneMeasureDTO, ZoneMeasure,
        forMember((dest) => dest.Color, mapFrom(source => '#' + source.color)),
        forMember((dest) => dest.TextColor, mapFrom(source => '#' + source.textColor)));
    createMap(mapper, CassetteDTO, Cassette,
        forMember((dest) => dest.Id, ignore()))
    createMap(mapper, PlageHoraireDTO, PlageHoraire, typeConverter(String, Temporal.PlainDateTime, (date) => Temporal.PlainDateTime.from(date)))
    createMap(mapper, PompeDTO, Pompe)
    createMap(mapper, SecuriteDTO, Securite)
    createMap(mapper, ZoneSamplingConditionDTO, ZoneSamplingCondition)
    createMap(mapper, ProcessCalculationDTO, ProcessCalculation)
    createMap(mapper, MeanOfPreventionDTO, MeanOfPrevention)
    createMap(mapper, GlobalTaskDTO, GlobalTask)
    createMap(mapper, ProcessTechniqueDTO, ProcessTechnique)
    createMap(mapper, ProcessMeasureDTO, ProcessMeasure,
        forMember((dest) => dest.Color, mapFrom(source => '#' + source.color)),
        forMember((dest) => dest.TextColor, mapFrom(source => '#' + source.textColor)));
    createMap(mapper, OperatorDTO, Operator)
    createMap(mapper, TaskDTO, Task, typeConverter(String, Temporal.PlainDateTime, (date) => Temporal.PlainDateTime.from(date)))
    createMap(mapper, ProcessSamplingConditionDTO, ProcessSamplingCondition)
    createMap(mapper, AreaMapDTO, AreaMap,
        forMember((dest) => dest.Id, ignore()))

    createMap(mapper, PointageJournalierDTO, PointageJournalier,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined))

    createMap(mapper, PointagePauseDTO, PointagePause,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined))
    // createMap(
    //     mapper,
    //     Bio,
    //     BioDto,
    //     typeConverter(Date, String, (date) => date.toDateString()),
    //     namingConventions(new CamelCaseNamingConvention()) forMember((dest) => dest.PlannedOnTimeSlot, mapFrom(source => source.plannedTimeSlot)
    // );
    createMap(mapper, MetrologieDTO, AppareilMesure)
    createMap(mapper, MeasureGenericDTO, MeasureGeneric)

};
addProfile(
    mapper,
    dtoProfile,
    namingConventions(new CamelCaseNamingConvention())
);

// createMap(mapper, User, UserDto); forMember((d) => d.ZPList, ignore()) , forMember((d) => d.Sampler, ignore()));